import { render } from "./detallePolizaReadOnly.vue?vue&type=template&id=0381acd0&scoped=true"
import script from "./detallePolizaReadOnly.vue?vue&type=script&lang=js"
export * from "./detallePolizaReadOnly.vue?vue&type=script&lang=js"

import "./detallePolizaReadOnly.vue?vue&type=style&index=0&id=0381acd0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0381acd0"]])

export default __exports__